export function ingestGate(input) {
    var _a;
    const missing = ((_a = input.missing) !== null && _a !== void 0 ? _a : [])
        .map((step) => (typeof step === "string" ? step.trim() : ""))
        .filter(Boolean);
    if (missing.length > 0) {
        return { dispatch: false, hold: "incomplete", missing };
    }
    if (input.initiator === "staff")
        return { dispatch: true };
    if (input.supplierTrusted)
        return { dispatch: true };
    return { dispatch: false, hold: "awaiting_review", missing: [] };
}
export function ingestHoldExplanation(hold, missing = []) {
    if (hold === "awaiting_review") {
        return "Waiting for Nenda to review the material. Nothing is sent for encoding until it is approved.";
    }
    const named = missing
        .map((step) => (typeof step === "string" ? step.trim() : ""))
        .filter(Boolean);
    return named.length > 0
        ? `Not sent yet — still missing: ${named.join(", ")}.`
        : "Not sent yet — the submission is not complete.";
}
